module.exports = __webpack_public_path__ + "img/logo_blanco[27].86685fa7.png";